<template>
  <div class="container">
      <section class="vacancy-list__title">
        <h2 class="text-center">
          Latest vacancies
        </h2>
      </section>
      <section >
        <div class="vacancy-cards-container">
          <div 
            class="vacancy-card" 
            v-for="(vacancy, index) in filtered" 
            :key="index"
          >
            <h4>{{ vacancy.title }}</h4>
            <p><strong>Location:</strong> {{ vacancy.region ? vacancy.region : 'Unknown' }}</p>
            <p><strong>Salary:</strong> {{ vacancy.salary ? vacancy.salary : 'N/A' }}</p>
            <a :href="vacancy.permalink" class="button button--type-primary">View vacancy</a>
          </div>

          <div v-if="filtered.length === 0" class="no-vacancies">
            <h4>No vacancies found</h4>
          </div>
        </div>

      </section>
  </div>
</template>

<script>
export default {
  props: {
    vacancies: {
      default: () => {
        return {};
      },
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      filter: {
        type: 'all',
      }
    }
  },
  computed: {
    filtered() {
      const filtered = [];
      this.vacancies.forEach(vacancy => {
        if((this.filter.type == vacancy.type || this.filter.type == 'all'))
          filtered.push(vacancy);
      });
      return filtered;
    }
  }
}
</script>

<style>

</style>